
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { HiOutlineMenuAlt3 as Bars3Icon, HiOutlineX as XMarkIcon, } from 'react-icons/hi';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
import useLocale from 'next-translate/useTranslation';
import ImagesWithDetailsAboutUs from '@/components/ImagesWithDetailsAboutUs';
import Certifications from '@/components/Certifications';
import { HiOutlineUserGroup as UserGroupIcon, HiOutlineSparkles as SparklesIcon, HiOutlineChip as CpuChipIcon, HiOutlineShieldCheck as ShieldCheckIcon, } from 'react-icons/hi';
import ButtonLink from '@/components/links/ButtonLink';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import ChatGPTComparisonNew from '@/components/landing/ChatGPTComparisonNew';
import { FormatUtils } from 'youtubei.js/agnostic';
const CoFounderMarianna = dynamic(() => import('@/components/CoFounderMarianna'));
const FounderDmytro = dynamic(() => import('@/components/FounderDmytro'));
const timelineData = [
    {
        nameKey: 'MVP Launch',
        descKey: 'mvp_launch_desc',
        dateKey: 'Sep 2022',
        dateTime: '2021-08',
    },
    {
        nameKey: 'Founded company',
        descKey: 'founded_company_desc',
        dateKey: 'August 2023',
        dateTime: '2021-12',
    },
    {
        nameKey: 'Best Web 3.0/AI Startup in Asia',
        descKey: 'best_startup_desc',
        dateKey: 'Jul 2024',
        dateTime: '2022-02',
    },
    {
        nameKey: 'Global Startup Awards Finalist',
        descKey: 'gsa_finalist_desc',
        dateKey: 'Sep 2024',
        dateTime: '2022-12',
    },
    {
        nameKey: 'Brands for Good — Honouree, Technology for Good',
        descKey: 'brands_for_good_desc',
        dateKey: 'Jul 2025',
        dateTime: '2025-07',
    },
    {
        nameKey: 'Google for Startups Accelerator: AI First (Singapore)',
        descKey: 'google_accelerator_desc',
        dateKey: 'Oct 2025',
        dateTime: '2025-10',
    },
];
const valuesData = [
    {
        icon: UserGroupIcon,
        titleKey: 'Customer-Centric Approach',
        descKey: 'customer_centric_desc',
    },
    {
        icon: SparklesIcon,
        titleKey: 'Agility and Innovation',
        descKey: 'agility_innovation_desc',
    },
    {
        icon: CpuChipIcon,
        titleKey: 'Empowering Through Automation',
        descKey: 'empowering_automation_desc',
    },
    {
        icon: ShieldCheckIcon,
        titleKey: 'Commitment to Trust and Compliance',
        descKey: 'trust_compliance_desc',
    },
];
export default function AboutUs() {
    const { t } = useLocale('about-us');
    const [theme, setTheme] = useState('light');
    // set theme on mount
    useEffect(() => {
        const theme = localStorage.getItem('theme');
        if (theme === 'dark' ||
            ((!('theme' in localStorage) || theme === 'system') &&
                window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            setTheme('dark');
        }
    }, []);
    return (<div className='bg-white dark:bg-slate-900'>
      <Seo templateTitle={t('About Us - Dmytro Olefyrenko and Marianna Olefyrenko')} title={t('About Easy-Peasy.AI')} description={t('Learn more about all-in-one AI platform and our mission')}/>

      <div className='relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20 dark:from-slate-800/20'>
        <LandingPageNavigation />

        <main className='isolate'>
          {/* Hero section */}
          <div className='relative isolate -z-10 overflow-hidden bg-gradient-to-b from-indigo-100/20 pt-14'>
            <div className='absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 dark:bg-slate-900 sm:-mr-80 lg:-mr-96' aria-hidden='true'/>
            <div className='mx-auto max-w-7xl px-6 py-32 sm:py-40 lg:px-8'>
              <div className='mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8'>
                <h1 className='max-w-2xl text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl lg:col-span-2 xl:col-auto'>
                  {t('Making AI Easy-Peasy')}
                </h1>
                <div className='mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1'>
                  <p className='text-lg leading-8 text-gray-600 dark:text-gray-300'>
                    {t('about_hero_description')}
                  </p>
                  <div className='mt-10 flex items-center gap-x-6'>
                    <ButtonLink href='/login?preset=bots' variant='dark'>
                      {t('Get started for free')}
                    </ButtonLink>
                    <span className='hidden text-sm font-semibold leading-6 text-gray-500 sm:block'>
                      {t('No credit card required')}
                    </span>
                  </div>
                </div>
                <Image src={theme === 'dark'
            ? '/images/about-us/GSA_logo_inverted.png'
            : '/images/about-us/Global Startup Awards.gif'} alt='' width={1000} height={1000} className='mt-0 aspect-[16/9] w-full max-w-lg rounded-2xl object-cover  sm:mt-1 lg:mt-0 lg:max-w-none xl:row-span-2 xl:row-end-2 xl:mt-6'/>
              </div>
            </div>
            <div className='absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white dark:from-slate-900 sm:h-32'/>
          </div>

          {/* Timeline section */}
          <div className='mx-auto -mt-8 max-w-7xl px-6 lg:px-8'>
            <div className='mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4'>
              {timelineData.map((item) => (<div key={item.nameKey}>
                  <time dateTime={item.dateTime} className='flex items-center text-sm font-semibold leading-6 text-indigo-600'>
                    <svg viewBox='0 0 4 4' className='mr-4 h-1 w-1 flex-none' aria-hidden='true'>
                      <circle cx={2} cy={2} r={2} fill='currentColor'/>
                    </svg>
                    {t(item.dateKey)}
                    <div className='absolute -ml-2 h-px w-screen -translate-x-full bg-gray-900/10 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0' aria-hidden='true'/>
                  </time>
                  <p className='mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-white'>
                    {t(item.nameKey)}
                  </p>
                  <p className='mt-1 text-base leading-7 text-gray-600 dark:text-gray-300'>
                    {t(item.descKey)}
                  </p>
                </div>))}
            </div>
          </div>

          {/* Content section - Our Awards */}
          <div className='mt-32 overflow-hidden sm:mt-40'>
            <div className='mx-auto max-w-7xl px-6 lg:flex lg:px-8'>
              <div className='mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8'>
                <div className='lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8'>
                  <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl'>
                    {t('Our Awards')}
                  </h2>
                  <p className='mt-6 text-xl leading-8 text-gray-600 dark:text-gray-300'>
                    {t('our_awards_description')}
                  </p>
                </div>
                <div className='flex flex-wrap items-start justify-center gap-6 sm:gap-8 lg:contents lg:justify-end'>
                  <div className='flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end'>
                    <Image src='/images/about-us/BrandsForGood_Awards.jpeg' alt='Easy Peasy AI Winner' className='h-[280px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[320px]' width={592} height={422}/>
                  </div>
                  <div className='contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8'>
                    <div className='flex justify-center self-center lg:order-first lg:w-auto lg:flex-none lg:justify-end lg:self-end'>
                      <Image src='/images/about-us/bizcert.png' alt='Global Web Awards' className='h-[240px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[240px]' width={384} height={288}/>
                    </div>
                    
                    <div className='flex w-96 flex-auto justify-end lg:w-auto lg:flex-none'>
                      <Image src='/images/about-us/EASY-PEASY-AI-GWA2.jpg' alt='Global Web Awards 2' className='h-[280px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[320px]' width={592} height={422}/>
                    </div>
                    <div className=' w-auto sm:block sm:flex-auto lg:flex-none'>
                      <Image src='/images/about-us/EASY-PEASY-AI-GWA3.jpeg' alt='Global Web Awards 3' className='h-[200px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[240px]' width={384} height={288}/>
                    </div>
                    <div className=' w-auto lg:block lg:flex-auto lg:flex-none'>
                      <Image src='/images/about-us/SME.jpg' alt='Global Web Awards 3' className='h-[200px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[240px]' width={384} height={288}/>
                    </div>
                    <div className='flex w-96 flex-auto justify-end lg:w-auto lg:flex-none'>
                      <Image src='/images/about-us/Easy_Peasy_AI_Winner.jpg' alt='Global Web Awards 2' className='h-[280px] w-full rounded-2xl bg-gray-50 object-cover lg:h-[320px]' width={592} height={422}/>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mission and Vision section */}
          <div className='relative isolate overflow-hidden px-6 py-48 sm:py-64 lg:px-8'>
            <div className='absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 dark:bg-slate-800 dark:ring-slate-700/50 sm:-mr-80 lg:-mr-96' aria-hidden='true'/>

            <div className='mx-auto max-w-7xl'>
              <div className='mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8'>
                <h1 className='max-w-2xl text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl lg:col-span-2 xl:col-auto'>
                  {t('Mission and Vision')}
                </h1>
              </div>

              <div className='mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 lg:mx-0 lg:mt-20 lg:max-w-none lg:grid-cols-2'>
                {/* Mission Card */}
                <div className='relative h-full'>
                  <div className='relative flex h-full flex-col overflow-hidden rounded-2xl bg-gradient-to-br from-white via-indigo-50/50 to-white shadow-lg dark:from-slate-800 dark:via-indigo-900/10 dark:to-slate-800'>
                    <div className='bg-grid-slate-100 dark:bg-grid-slate-700/25 absolute inset-0 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] dark:[mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.5))]'></div>
                    <div className='relative flex-1 p-8'>
                      <div className='mb-6'>
                        <div className='inline-flex items-center rounded-lg bg-white/80 px-3 py-2 shadow-sm ring-1 ring-slate-900/5 dark:bg-slate-800/80 dark:ring-white/10'>
                          <svg className='h-6 w-6 text-indigo-600 dark:text-indigo-400' fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z'/>
                          </svg>
                          <span className='ml-3 font-medium text-indigo-600 dark:text-indigo-400'>
                            {t('Our Mission')}
                          </span>
                        </div>
                      </div>
                      <p className='text-base leading-7 text-gray-600 dark:text-gray-300'>
                        {t('mission_description')}
                      </p>
                      <ul className='mt-8 space-y-3'>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-indigo-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Accessible AI Tools')}
                        </li>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-indigo-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Ethical Solutions')}
                        </li>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-indigo-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Inclusive Technology')}
                        </li>
                      </ul>
                    </div>
                    <div className='relative border-t border-slate-900/5 bg-white/50 px-8 py-4 backdrop-blur-sm dark:border-white/5 dark:bg-slate-800/50'>
                      <div className='flex items-center justify-between text-sm font-medium text-indigo-600 dark:text-indigo-400'>
                        <span>
                          {t('Empowering users through accessible AI solutions')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Vision Card */}
                <div className='relative h-full'>
                  <div className='relative flex h-full flex-col overflow-hidden rounded-2xl bg-gradient-to-br from-white via-blue-50/50 to-white shadow-lg dark:from-slate-800 dark:via-blue-900/10 dark:to-slate-800'>
                    <div className='bg-grid-slate-100 dark:bg-grid-slate-700/25 absolute inset-0 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] dark:[mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.5))]'></div>
                    <div className='relative flex-1 p-8'>
                      <div className='mb-6'>
                        <div className='inline-flex items-center rounded-lg bg-white/80 px-3 py-2 shadow-sm ring-1 ring-slate-900/5 dark:bg-slate-800/80 dark:ring-white/10'>
                          <svg className='h-6 w-6 text-blue-600 dark:text-blue-400' fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z'/>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'/>
                          </svg>
                          <span className='ml-3 font-medium text-blue-600 dark:text-blue-400'>
                            {t('Our Vision')}
                          </span>
                        </div>
                      </div>
                      <p className='text-base leading-7 text-gray-600 dark:text-gray-300'>
                        {t('vision_description')}
                      </p>
                      <ul className='mt-8 space-y-3'>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-blue-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Task Automation')}
                        </li>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-blue-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Human-Centric Approach')}
                        </li>
                        <li className='flex items-center text-gray-600 dark:text-gray-300'>
                          <svg className='mr-2 h-5 w-5 text-blue-600' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/>
                          </svg>
                          {t('Enhanced Productivity')}
                        </li>
                      </ul>
                    </div>
                    <div className='relative border-t border-slate-900/5 bg-white/50 px-8 py-4 backdrop-blur-sm dark:border-white/5 dark:bg-slate-800/50'>
                      <div className='flex items-center justify-between text-sm font-medium text-blue-600 dark:text-blue-400'>
                        <span>
                          {t('Transforming work through intelligent automation')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white dark:from-slate-900 sm:h-32'/>
          </div>

          {/* Stats */}
          <div className='mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8'>
            <div className='mx-auto max-w-2xl lg:mx-0'>
              <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl'>
                {t('The Agile Culture')}
              </h2>
              <p className='mt-6 text-base leading-7 text-gray-600 dark:text-gray-300'>
                {t('agile_culture_description')}
              </p>
            </div>
            <div className='mx-auto mt-16 flex max-w-2xl flex-col gap-8 lg:mx-0 lg:mt-20 lg:max-w-none lg:flex-row lg:items-end'>
              <div className='flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-200 p-8 sm:w-3/4 sm:max-w-md sm:flex-row-reverse sm:items-end lg:w-72 lg:max-w-none lg:flex-none lg:flex-col lg:items-start'>
                <p className='flex-none text-3xl font-bold tracking-tight text-gray-900'>
                  {t('2M+ Users')}
                </p>
                <div className='sm:w-80 sm:shrink lg:w-auto lg:flex-none'>
                  <p className='mt-2 text-base leading-7 text-gray-600'>
                    {t('users_description')}
                  </p>
                </div>
              </div>
              <div className='flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-900 p-8 sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-sm lg:flex-auto lg:flex-col lg:items-start lg:gap-y-44'>
                <p className='flex-none text-3xl font-bold tracking-tight text-white'>
                  {t('150+ Countries')}
                </p>
                <div className='sm:w-80 sm:shrink lg:w-auto lg:flex-none'>
                  <p className='text-lg font-semibold tracking-tight text-white'>
                    {t('countries_description')}
                  </p>
                </div>
              </div>
              <div className='flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-indigo-600 p-8 sm:w-11/12 sm:max-w-xl sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-none lg:flex-auto lg:flex-col lg:items-start lg:gap-y-28'>
                <p className='flex-none text-3xl font-bold tracking-tight text-white'>
                  {t('4.8 User Rank')}
                </p>
                <div className='sm:w-80 sm:shrink lg:w-auto lg:flex-none'>
                  <p className='mt-2 text-base leading-7 text-indigo-200'>
                    {t('user_rank_description')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Values section */}
          <div className='mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8'>
            <div className='mx-auto flex max-w-2xl flex-col items-end justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row'>
              <div className='w-full lg:max-w-lg lg:flex-auto'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl'>
                  {t('Our Values')}
                </h2>
                <p className='mt-6 text-xl leading-8 text-gray-600 dark:text-gray-300'>
                  {t('our_values_description')}
                </p>
                <Image src='/images/about-us/Easy-Peasy-AI-BNI-new.jpg' alt='' width={600} height={600} className='mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]'/>
              </div>
              <div className='w-full lg:max-w-xl lg:flex-auto'>
                <h3 className='sr-only'>{t('Our Values')}</h3>
                <ul className='-my-8 divide-y divide-gray-100'>
                  <li className='py-8'>
                    <dl className='relative flex flex-wrap gap-x-3'>
                      <dd className='mt-6 w-full'>
                        <div className='grid grid-cols-1 gap-8 pt-5 sm:grid-cols-2'>
                          {valuesData.map((value, index) => (<div key={index} className='relative flex flex-col gap-6 rounded-2xl bg-gray-50 p-6 dark:bg-gray-800/50'>
                              <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-500 text-white'>
                                <value.icon className='h-6 w-6' aria-hidden='true'/>
                              </div>
                              <div>
                                <h3 className='text-lg font-semibold leading-7 text-gray-900 dark:text-white'>
                                  {t(value.titleKey)}
                                </h3>
                                <p className='mt-2 text-base leading-7 text-gray-600 dark:text-gray-300'>
                                  {t(value.descKey)}
                                </p>
                              </div>
                            </div>))}
                        </div>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </main>

        <FounderDmytro />
        <CoFounderMarianna reverse/>

        <Certifications />
        <ImagesWithDetailsAboutUs />

        <Footer />
      </div>
    </div>);
}

    async function __Next_Translate__getStaticProps__1a0cbfb66d1__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about-us',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb66d1__ as getStaticProps }
  